module.exports = __webpack_public_path__ + "static/prem_bitkowski-2053ee4034c1cb1a090d378e19acbd30.png";